import { useCallback, useSyncExternalStore } from "react";
import type { ChatSession } from "./chat-api";
import { readSaved, saveValue, workbenchScope } from "./workbench-storage";
const changed = "swarm-activity-read";
function subscribe(notify: () => void) {
  window.addEventListener(changed, notify);
  window.addEventListener("storage", notify);
  return () => { window.removeEventListener(changed, notify); window.removeEventListener("storage", notify); };
}
export function useReadActivity() {
  const key = workbenchScope() + ":read";
  const raw = useSyncExternalStore(subscribe, useCallback(() => {
    try { return localStorage.getItem(key) ?? "{}"; } catch { return "{}"; }
  }, [key]), () => "{}");
  let read: Record<string, string> = {};
  try { read = validMarkers(JSON.parse(raw)); } catch { /* Ignore corrupt local preferences. */ }
  return {
    unread: (session: ChatSession) => !!session.last_turn_status && !["queued", "running"].includes(session.last_turn_status) && (!read[session.id] || read[session.id] < session.last_activity_at),
    markRead: (sessions: ChatSession[]) => {
      const next = validMarkers(readSaved<unknown>(key, {}));
      for (const session of sessions) next[session.id] = session.last_activity_at;
      saveValue(key, next);
      window.dispatchEvent(new Event(changed));
    },
  };
}

function validMarkers(value: unknown): Record<string, string> {
  return value && typeof value === "object" && !Array.isArray(value)
    ? Object.fromEntries(Object.entries(value).filter(([, time]) => typeof time === "string")) : {};
}
